import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import DataTableOperationsDetails from "./DataTableOperationsDetails";



const DataTableBOMDetails=(listBOM)=>{
    console.log("listComponent", listBOM);
    const [transactions, setTransactions] = useState(listBOM.listBOM);
  

    function titleFormatter(cell, row) {
      console.log("titleFormatter", row);
      return (
        <span>
          {row.product.productCode}-{row.product.name}
        </span>
      );
    }
    function uniteFormatter(cell, row) {
      return (
        <span>
          {row.unitOfMeasure.code}-{row.unitOfMeasure.name}
        </span>
      );
    }
  
    const columns = [
      {
        dataField: "id",
        text: "Titre",
        align: "center",
        headerAlign: "center",
        formatter: titleFormatter,
      },
      {
        dataField: "quantity",
        text: "QTE",
        align: "center",
        headerAlign: "center",
        headerStyle: () => {
          return { width: "15%" };
        },
      },
      {
        dataField: "unitOfMeasure.id",
        text: "Unité de mesure",
        align: "center",
        headerAlign: "center",
        formatter: uniteFormatter,
  
        headerStyle: () => {
          return { width: "15%" };
        },
      },
    ];
  
    const importProduct = (row) => {
      console.log("importProduct", row);
      if (row.boms != null) {
        return (
          <div>
             {/* style={{backgroundColor:"yellow"}} */}
          <label>{row.boms.code}</label>
          <br/>
          <label>{row.product.productCode}-{row.product.name}</label>
          <br/>
          <label>{row.boms.quantity} {" "}{row.boms.unitOfMeasure.code}-{row.boms.unitOfMeasure.name}</label>
          <br/>
          <label>Les composants</label>
          <DataTableBOMDetails listBOM={row.boms.componentList}/>
          <label>Les opérations</label>
          <DataTableOperationsDetails listOperation={row.boms.operations}/>
          {/* {row.transactionOperations &&
            row.transactionOperations.map((element, i) => (
              <div className="row">
                {" "}
                <div class="col-md-12">
                  {row.facture !== null &&
                    buttonFormatter(element, row.facture.ref)}
                  {row.purchaseOrder !== null &&
                    buttonFormatter(element, row.purchaseOrder.ref)}
                  
                </div>
                {rates(element)}
              </div>
            ))} */}
        </div>
        );
      } else {
        return <div></div>;
      }
    };
    const expandRow = {
      renderer: (row) => importProduct(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
    };
  
    // const handleInfoClose = (event, reason) => {
    //   if (reason === "clickaway") {
    //     return;
    //   }
    //   setOpenInfoAlert(false);
    // };
  
    function handleTableChange({ products }) {
      return products;
    }
    const pageButtonRenderer = ({
      page,
      active,
      disable,
      title,
      onPageChange,
    }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      const activeStyle = {};
      if (active) {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      } else {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      if (typeof page === "string") {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      return (
        <li className="page-item">
          <button
            className="btn btn-dark"
            onClick={handleClick}
            style={activeStyle}
          >
            {page}
          </button>
        </li>
      );
    };
    const options = {
      pageButtonRenderer,
    };
  
    return (
      <ToolkitProvider keyField="id" data={transactions} columns={columns}>
        {(props) => (
          <div>
            <div className="row">
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
                expandRow={expandRow}
              />
            </div>
          </div>
        )}
      </ToolkitProvider>
    );
}

export default DataTableBOMDetails;